export var TimeUnit;
(function (TimeUnit) {
    TimeUnit["Milliseconds"] = "milliseconds";
    TimeUnit["Seconds"] = "seconds";
    TimeUnit["Minutes"] = "minutes";
    TimeUnit["Hours"] = "hours";
    TimeUnit["Days"] = "days";
    TimeUnit["Weeks"] = "weeks";
})(TimeUnit || (TimeUnit = {}));
